import useUiuxStore from "src/store/useUiuxStore";
import { showWarning } from "src/utils/toast/toastUtil";
import { validateItemAccount, isDuplicateChildItemcd, restoreOriginalValues } from "../Util_KSK2090_R01";
import { KSK2090_R01DetailDto } from "../Dto_KSK2090_R01";

interface UseBomModalProps {
	updateKSK2090_R01Detail: (index: number, data: KSK2090_R01DetailDto) => void;
	gridRef: any;
	KSK2090_R01DetailList: KSK2090_R01DetailDto[];
}

export function useCoordinateModal({ updateKSK2090_R01Detail, gridRef, KSK2090_R01DetailList }: UseBomModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	// 모달 닫힘 콜백
	const handlePopupClose = () => {
		if (gridRef.current?.api) {
		gridRef.current.api.stopEditing();
		}
	};

	// 코드검색 모달 열기 및 처리
	const settingCodeSearchModalProps = (
		category: string,
		search: string,
		isInfo: boolean,
		handleFoucsId: string,
		originalData: KSK2090_R01DetailDto,
		valueIndex: number,
	) => {
		setCodeSearchModalProps({
			category,
			search,
			formName: 'KSK2090_R01',
			isInfo,
			handleFoucsId,
			onClear: () => {
				const updateData: Partial<KSK2090_R01DetailDto> = {
					...originalData,
					isModified: false
				};

				if (handleFoucsId === 'childItemcd') {
					updateData.childItemcd = '';
					updateData.childItemnm = '';
				} else if (handleFoucsId === 'afeederCd') {
					updateData.afeederCd = '';
				} else if (handleFoucsId === 'bfeederCd') {
					updateData.bfeederCd = '';
				} else if (handleFoucsId === 'cfeederCd') {
					updateData.cfeederCd = '';
				}

				updateKSK2090_R01Detail(valueIndex, updateData as KSK2090_R01DetailDto);
				handlePopupClose();
			},
			onConfirm: (data: any) => {
				const updateData: Partial<KSK2090_R01DetailDto> = {
					...originalData,
					isModified: originalData.inserted ? false : true,
				};

				if (handleFoucsId === 'childItemcd') {
					updateData.childItemcd = data.childItemcd || '';
					updateData.childItemnm = data.itemNm || '';
					
					if (data.itemAccount && !validateItemAccount(data.itemAccount)) {
						showWarning(
							`선택한 품목(${data.itemNm})은 BOM 등록이 불가능한 계정입니다.\n허용 품목 계정: 재공품, 원자제 , 부자재}`,
							5000
						);
						restoreOriginalValues(valueIndex, originalData, updateKSK2090_R01Detail, gridRef);
						return;
					}
				} else if (handleFoucsId === 'afeederCd') {
					updateData.afeederCd = data.minorCd || '';
				} else if (handleFoucsId === 'bfeederCd') {
					updateData.bfeederCd = data.minorCd || '';
				} else if (handleFoucsId === 'cfeederCd') {
					updateData.cfeederCd = data.minorCd || '';
				}

				const currentRow = KSK2090_R01DetailList.find(item => item.valueIndex === valueIndex);
				if (currentRow && data) {
					updateKSK2090_R01Detail(valueIndex, {
						...currentRow,
						...updateData,
						isModified: true
					});
				}
				setTimeout(() => {
				const api = gridRef.current?.api;
				if (!api) return;
				}, 0);
			},
			wrapperOption: {
				overlay: true
			},
		});
	};

	return { settingCodeSearchModalProps, handlePopupClose };
} 